<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="mobile"
    size="small"
    label-position="left"
    label-width="290px"
  >
    <el-dialog
      :class="dialogclass"
      width="75%"
      :visible.sync="popup"
    >
      <h3 slot="title">Motif de résiliation ?</h3>

      <el-row class="choices" :gutter="10">
        <el-col :span="12">
          <el-radio v-model="form.motif" label="Droit de rétractation (14 jours)" border>
            Droit de rétractation (14 jours)
          </el-radio>
          <el-radio v-model="form.motif" label="Cessation d'activité professionnelle" border>
            Cessation d'activité professionnelle
          </el-radio>
          <el-radio v-model="form.motif" label="Changement de domicile (déménagement)" border>
            Changement de domicile (déménagement)
          </el-radio>
          <el-radio v-model="form.motif" label="Changement de situation / régime matrimonial" border>
            Changement de situation / régime matrimonial
          </el-radio>
          <el-radio v-model="form.motif" label="Changement de profession" border>
            Changement de profession
          </el-radio>
          <el-radio v-model="form.motif" label="Augmentation de tarif (non justifiée par une aggravation du risque)" border>
            Augmentation de tarif (non justifiée par une aggravation du risque)
          </el-radio>
        </el-col>
        <el-col :span="12">
          <el-radio v-model="form.motif" label="Avis d'échéance reçu hors délai" border>
            Avis d'échéance reçu hors délai
          </el-radio>
          <el-radio v-model="form.motif" label="Contrat reconduit sans notification (Loi Chatel)" border>
            Contrat reconduit sans notification (Loi Chatel)
          </el-radio>
          <el-radio v-model="form.motif" label="Décès de l'assuré" border>
            Décès de l'assuré
          </el-radio>
          <el-radio v-model="form.motif" label="Mise en demeure" border>
            Mise en demeure
          </el-radio>
          <el-radio v-model="form.motif" label="Résiliation à l'échéance annuelle" border>
            Résiliation à l'échéance annuelle
          </el-radio>
          <el-radio v-model="form.motif" label="Autres raisons" border>
            Autres raisons
          </el-radio>
        </el-col>
      </el-row>

      <el-button type="danger" @click.prevent="close()">
        Continuer
      </el-button>
    </el-dialog>

    <p style="border-bottom: 1px solid #f1f1f1;padding-bottom:10px">Vous devez saisir les informations ci-dessous pour résilier votre mutuelle :</p>

    <el-row class="choices small" :gutter="10">
      <el-col :span="12">
        <el-radio v-model="form.motif" label="Droit de rétractation (14 jours)" border>
          Droit de rétractation (14 jours)
        </el-radio>
        <el-radio v-model="form.motif" label="Cessation d'activité professionnelle" border>
          Cessation d'activité professionnelle
        </el-radio>
        <el-radio v-model="form.motif" label="Changement de domicile (déménagement)" border>
          Changement de domicile (déménagement)
        </el-radio>
        <el-radio v-model="form.motif" label="Changement de situation / régime matrimonial" border>
          Changement de situation / régime matrimonial
        </el-radio>
        <el-radio v-model="form.motif" label="Changement de profession" border>
          Changement de profession
        </el-radio>
        <el-radio v-model="form.motif" label="Augmentation de tarif (non justifiée par une aggravation du risque)" border>
          Augmentation de tarif (non justifiée par une aggravation du risque)
        </el-radio>
      </el-col>
      <el-col :span="12">
        <el-radio v-model="form.motif" label="Avis d'échéance reçu hors délai" border>
          Avis d'échéance reçu hors délai
        </el-radio>
        <el-radio v-model="form.motif" label="Contrat reconduit sans notification (Loi Chatel)" border>
          Contrat reconduit sans notification (Loi Chatel)
        </el-radio>
        <el-radio v-model="form.motif" label="Décès de l'assuré" border>
          Décès de l'assuré
        </el-radio>
        <el-radio v-model="form.motif" label="Mise en demeure" border>
          Mise en demeure
        </el-radio>
        <el-radio v-model="form.motif" label="Résiliation à l'échéance annuelle" border>
          Résiliation à l'échéance annuelle
        </el-radio>
        <el-radio v-model="form.motif" label="Autres raisons" border>
          Autres raisons
        </el-radio>
      </el-col>
    </el-row>

    <el-form-item ref="contract" prop="contract" required style="margin-top: 40px">
      <span slot="label" class="label-logo">
        Numéro de contrat <img :src="logo"  :class="classname" />
      </span>
      <el-input v-model="form.contract" ref="contract" />
      <span class="notice">
        <i class="el-icon-info" /> Vos références se trouvent sur vos factures ou votre espace client.
      </span>
    </el-form-item>

    <el-form-item prop="informations"
                  style="margin-top: 40px">
      <span slot="label">
        Informations complémentaires
      </span>
      <el-input v-model="form.informations" type="textarea"
                rows="2"
                placeholder="Précisez ici le bien à résilier (si vous avez plusieurs véhicules, logements...)" />
    </el-form-item>

    <el-upload
      v-if="uploadDocument"
      :action="uploadUrl"
      :headers="headers"
      :on-success="uploadSuccess"
      accept=".pdf"
      :limit="1"
    >
      <el-button size="small" type="primary">Cliquez ici pour choisir un document</el-button>
      <small slot="tip">
        <strong>Vous devez nous transmettre un justificatif du changement de situation</strong><br>
        Le document doit être au format .pdf
      </small>
    </el-upload>

    <el-alert
      v-if="uploadError"
      type="error"
      title="Vous devez scanner et envoyer un document pdf"
      show-icon
      :closable="false"
    />

    <Cgu
      id="cgu"
      :rows="8"
      :contact="contact"
      currency="eur"
    />

    <el-form-item class="cgu" prop="cgu">
      <el-checkbox v-model="form.cgu">
        J'ai lu et j'accepte les conditions générales ci-dessus
      </el-checkbox>
    </el-form-item>

    <div class="valider">
      <el-button
        round
        icon="el-icon-caret-right"
        type="danger"
        :loading="loading"
        @click.prevent="valide"
      >
        Je valide ma demande
      </el-button>

      <p class="delai">
        la résiliation sera effective dans un délai de dix jours maximum à compter de la réception
        du dossier.
        <span class="legal">(Conformément aux dispositions de l’article L.224-39 du code de la
          consommation)</span>
      </p>

      <img src="../../assets/images/secure-payment.png" />
    </div>
  </el-form>
</template>

<script>
import axios from 'axios'
import Cgu from '../cgu.vue'

export default {
  props: {
    contract: String,
    loading: Boolean,
    contact: String,
    type: String,
    motif: String,
    informations: String,
    description: String,
    reference: String,
    title: String,
    attachment: String
  },
  components: {
    Cgu
  },
  data () {
    const cgu = (rule, value, callback) => {
      if (value !== true) {
        callback(new Error('Vous devez lire et accepter les conditions générales'))
      } else {
        callback()
      }
    }
    return {
      uploadError: false,
      popup: true,
      defaultType: this.type,
      form: {
        contract: this.contract,
        motif: this.motif,
        informations: this.informations,
        type: this.type,
        cgu: false,
        attachment: this.attachment
      },
      rules: {
        contract: [
          { required: true, message: 'Saisissez votre ' + this.reference, trigger: 'blur' }
        ],
        cgu: [
          { validator: cgu, trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    uploadDocument () {
      return this.motif === 'Cessation d\'activité professionnelle' ||
        this.motif === 'Changement de domicile (déménagement)' ||
        this.motif === 'Changement de situation / régime matrimonial' ||
        this.motif === 'Changement de profession' ||
        this.motif === 'Décès de l\'assuré'
    },
    uploadUrl () {
      return axios.defaults.baseURL + 'attachment/upload'
    },
    headers () {
      return axios.defaults.headers.common
    },
    logo () {
      return '/static/images/logos/' + this.classname + '.png'
    },
    dialogclass () {
      return 'pre-select ' + this.classname + '-select'
    },
    classname () {
      return this.description.replace(/\s+/g, '').toLowerCase()
    }
  },
  methods: {
    uploadSuccess (res) {
      this.$emit('update:attachment', res.filename)
    },
    valide () {
      this.$refs.mobile.validate((valid) => {
        if (valid) {
          this.$emit('valide', this.form)
        }
      })
    },
    close () {
      this.popup = false
      this.$refs.contract.onFieldBlur()
    }
  },
  watch: {
    contract (value) {
      this.form.contract = value
    },
    motif (value) {
      this.form.motif = value
    },
    informations (value) {
      this.form.informations = value
    },
    attachment (value) {
      this.form.attachment = value
    },
    form: {
      handler (value) {
        if (value) {
          this.$emit('update:motif', value.motif)
          this.$emit('update:contract', value.contract)
          this.$emit('update:informations', value.informations)
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  #cgu {
    height: 8em;
    overflow: auto;
    max-width: 600px;
    margin: 50px auto 30px;
    text-align: left;
    font-size: 11px;
  }
  #form .el-form-item {
    max-width: 675px;
  }
  .valider {
    img {
      max-width: 250px;
      margin-top: 25px;
    }
  }
  .delai {
    margin-top: 40px;
    color: #000;
    font-size: 14px;

    .legal {
      font-size: 10px;
      display: block;
    }
  }
  .notice {
    color: #444;
    font-size: 12px;
  }
  .el-select {
    width: 100%;
  }
  .choices {
    text-align: left;
    .el-radio {
      margin: 5px 0 !important;
      display: block;
    }
  }
  .info {
    padding-top: 15px;
    color: #000;
    font-size: 16px;

    &.small {
      font-size: 12px;
      padding-top: 0;
    }
  }
</style>

<style lang="scss">
  .el-form-item.cgu {
    max-width: 600px;
    margin: 0 auto 15px !important;

    .el-form-item__content {
      padding-top: 10px;
      margin-left: 0 !important;
      text-align: center;
    }
    .el-checkbox__label {
      font-weight: bold;
      font-size: 16px;
    }
  }
  .pre-select {
    .el-dialog__header {
      background-size: 125px;
      background-position: top 20px center;
      background-repeat: no-repeat;
      padding-top: 70px;
    }
    .el-button {
      margin-top: 40px;
    }
    &.mma-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/mma.png);
      }
    }
    &.axa-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/axa.png);
        background-size: 50px;
      }
    }
    &.pacifica-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/pacifica.png);
        background-size: 80px;
      }
    }
    &.directassurance-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/directassurance.png);
        background-size: 50px;
      }
    }
    &.maif-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/maif.png);
        background-size: 50px;
      }
    }
    &.macif-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/macif.png);
        background-size: 50px;
      }
    }
    &.gmf-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/gmf.png);
        background-size: 50px;
      }
    }
    &.groupama-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/groupama.jpg);
        background-size: 175px;
      }
    }
    &.matmut-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/matmut.jpg);
        background-size: 80px;
      }
    }
    &.generali-select {
      .el-dialog__header {
        background-image: url(/static/images/logos/generali.png);
        background-size: 70px;
      }
    }
  }
  .label-logo {
    position: relative;

    img {
      max-height: 24px;
      position: absolute;
      left: 130px;
      top: -3px;

      &.orange {
        max-height: 64px;
        left: 90px;
        top: -23px;
      }
    }
  }
  .choices.small {
    max-width: 900px;
    margin: 0 auto !important;

    .el-radio__label {
      font-weight: bold;
      font-size: 12px;
    }
  }

  .el-upload--text {
    display: block !important;
    text-align: center !important;
    margin-top: 30px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/mutuelle.vue